import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { CopyToClipboard } from 'react-copy-to-clipboard'
import '../index.css'

class Gallery extends Component {

  constructor() {
    super();
    this.state = {
      photoIndex: 0,
      isOpen: false,
      clickeado: false
    };
  }

  componentWillReceiveProps() {
      this.setState({clickeado: false})
  }

  copiarLink = () => {
    this.setState({clickeado: true})
  }

  render() {
    const { photoIndex, isOpen } = this.state;
    const currentElement = this.props.mainState.gallery[this.props.dato.galleryNumber];
    const images = currentElement.fields.Fotos;
    const urlToCopy = window.location.href.replace(/[^/]*$/, currentElement.id);
    console.log(currentElement)

    return (
      <div>
        <div className="row">
          <h3 dangerouslySetInnerHTML={{ __html: currentElement.fields.Fecha }}/>
          <br/>
          {currentElement.fields.LinkMaestria &&
            <div>
              <b>Link a la tesis:</b> <a href={currentElement.fields.LinkMaestria} target="_blank">{currentElement.fields.LinkMaestria}</a>
              <br/>
              <br/>
            </div>
          }
          <p dangerouslySetInnerHTML={{ __html: currentElement.fields.Descripcion }}/>
        </div>
        <div className="row" style={{paddingBottom:"30px", textAlign:"end"}}>
          <button className="rm-btn el-btn-regular flacso-verde" style={{color:'black', backgroundColor:'white'}}>
            {urlToCopy}
          </button>
          <CopyToClipboard text={urlToCopy}>
            <button className="rm-btn el-btn-regular flacso-verde" onClick={() => this.copiarLink()} style={{width:"144px"}}>
              {this.state.clickeado ? "Copiado!" : "Copiar Link"}
            </button>
          </CopyToClipboard>
        </div>
        <div className="row">
          { currentElement.fields.Fotos && (
            currentElement.fields.Fotos.map((elem, index) =>
            <div key={index} className='col-md-4 photo-div'>
              <img src={elem.thumbnails.large.url} 
                 alt="" 
                 onClick={() => this.setState({ isOpen: true, photoIndex: index })} 
                 key={index} 
                 className='photo-img'
                 />
            </div>
          ))}
          { currentElement.fields.Videos && (
            currentElement.fields.Videos.split(" ").map((elem, index) =>
            <iframe key={index} 
                    title="Galeria" 
                    width="560" 
                    height="315" 
                    src={elem} 
                    frameBorder="1" 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen style={{ "width": "50%", "cursor": "pointer" }}/>
          ))}
        </div>

        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex].thumbnails.full.url}
            nextSrc={images[(photoIndex + 1) % images.length].thumbnails.full.url}
            prevSrc={images[(photoIndex + images.length - 1) % images.length].thumbnails.full.url}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }
          />
        )}

      </div>
    )
  }

}
export default Gallery;
